import { twMerge } from 'tailwind-merge';
import Bathrooms from '../../../svgs/bathrooms';
import Bedrooms from '../../../svgs/bedrooms';

export default function RoomIcons({
  bedrooms,
  bathrooms,
  className = '',
}: {
  bedrooms: number | null;
  bathrooms: number | null;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        'flex flex-row items-center justify-start gap-4 text-xs tracking-wide font-bold',
        className
      )}
    >
      {!!bedrooms && (
        <span className="flex flex-row gap-2 text-sm items-center">
          <Bedrooms className="fill-black h-7 w-auto" />
          {bedrooms}
        </span>
      )}

      {!!bathrooms && (
        <span className="flex flex-row gap-2 text-sm items-center">
          <Bathrooms className="fill-black h-8 w-auto" />
          {bathrooms}
        </span>
      )}
    </div>
  );
}
